export const icons = [
  'Icon_BedOutlined.svg',
  'Icon_ChairAltOutlined.svg',
  'Icon_ChairOutlined.svg',
  'Icon_Dresser.svg',
  'Icon_FloorLamp.svg',
  'Icon_TableRestaurantOutlined.svg'
];

export const serverUrl = process.env.NEXT_PUBLIC_SERVER_URL || 'http://localhost:5000/';
